import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { Toaster } from "react-hot-toast";
import AOS from "aos";
import "aos/dist/aos.css";
import Footer from "./components/footer";
import Home from "./pages/Home";
import Speakers from "./pages/Speakers";
import Agenda from "./pages/Agenda";
import Registration from "./pages/Register";
import CodeOfConduct from "./pages/CodeOfConduct";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";
import AdminDashboard from "./pages/AdminDashboard";
import { AuthProvider } from "./context/AuthContext";
import AnimatedBackground from "./components/AnimatedBackground";
import ProtectedRoute from "./components/ProtectedRoute";
import About from "./pages/About";
import Event from "./pages/Events";
import Venue from "./pages/ Venue";
import Committee from "./pages/Committee";
import Awards from "./pages/Awards";
import GlobalNavbar from "./components/globalnav";
import CallForAbstracts from "./pages/CallForAbstracts";
import Topics from "./pages/Topics";
import Abstract from "./pages/Abstract";
import Sponsors from "./pages/Sponsors";
import SummitDetails from "./pages/summitdetails";
import { App as GlobalHome } from "./global/Globalhome";
import Globalsponser from "./global/Globalsponser";
import AboutInformation from "./global/AboutInformation";
import RegistrationPoliciesPage from "./components/RegistrationPoliciesPage";
import RegistrationFeePage from "./components/Registrationfee";
import AbstractSubmission from "./pages/AbstractSubmission";
import ProgrammeOverview from './components/ProgrammeOverview';
import ScheduleTab from './components/SchedulePage';
import GuidelinesPage from './pages/Guidelines';
import PresentationGuidelinesPage from './pages/PresentationGuidelinesPage';
import SummitPublications from "./components/summitPublications";
import SubmissionGuidelines from './pages/SubmissionGuidelines';
import SummitManagement from "./admin/SummitManagement";
import ContactManagement from "./admin/ContactManagement";
import SlugManagement from './pages/slugmanagement';
import GlobalContact from './pages/globalcontact';

// ✅ ScrollToTop – safely uses useLocation inside Router
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

// ✅ Layout wrapper – hides navbar/footer on dashboard routes
function Layout({ children }) {
  // Check if the current path starts with /dashboard
  const isDashboard = window.location.pathname.startsWith("/dashboard");
  return (
    <>
      {!isDashboard && <GlobalNavbar />}
      <ScrollToTop />
      <main className="relative z-10">{children}</main>
      {!isDashboard && <Footer />}
    </>
  );
}

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      mirror: false,
      offset: 100,
      disable: "mobile",
    });
    return () => {
      AOS.refresh();
    };
  }, []);

  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gradient-to-br from-deep-navy via-slate-900 to-deep-navy relative">
          <AnimatedBackground />
          <Layout>
            <Routes>
              {/* Main Site Routes */}
              <Route path="/" element={<Home />} />
              <Route path="/speakers" element={<Speakers />} />
              <Route path="/agenda" element={<Agenda />} />
              <Route path="/register" element={<Registration />} />
              <Route path="/code-of-conduct" element={<CodeOfConduct />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/policies" element={<PrivacyPolicy />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/about" element={<About />} />
              <Route path="/events" element={<Event />} />
              <Route path="/venue" element={<Venue />} />
              <Route path="/sponsors" element={<Sponsors />} />
              <Route path="/committee" element={<Committee />} />
              <Route path="/schedule" element={<ScheduleTab />} />
              <Route path="/awards" element={<Awards />} />
              <Route path="/abstract-submission" element={<AbstractSubmission />} />
              <Route path='/summit-publications' element={<SummitPublications />} />
              <Route path="/presentation-guidelines" element={<PresentationGuidelinesPage />} />
              <Route path="/call-for-abstracts" element={<CallForAbstracts />} />
              <Route path="/topics" element={<Topics />} />
              <Route path="/abstract" element={<Abstract />} />
              <Route path="/globalhome" element={<GlobalHome />} />
              <Route path="/globalsponser" element={<Globalsponser />} />
              <Route path="/about-information" element={<AboutInformation />} />
              <Route path="/registration-policies" element={<RegistrationPoliciesPage />} />
              <Route path="/programme-overview" element={<ProgrammeOverview />} />
              <Route path="/guidelines" element={<GuidelinesPage />} />
              <Route path="/submission-guidelines" element={<SubmissionGuidelines />} />
              <Route path="/registration-fee" element={<RegistrationFeePage />} />
              <Route path="/contact-management" element={<ContactManagement />} />
              <Route path="/globalcontact" element={<GlobalContact />} />
              <Route path="/summit-management" element={<SummitManagement />} />
              <Route path="/slug" element={<SlugManagement />} />
              <Route path="/summit-management/:eventId" element={<SummitManagement />} />

              {/* Summit/Event Routes */}
              <Route path="/agenda/:id/*" element={<SummitDetails />} />
              <Route path="/event/:id/*" element={<SummitDetails />} />

              {/* Protected Admin Routes */}
              <Route
                path="/dashboard/*"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </Layout>
          <Toaster
            position="top-right"
            toastOptions={{
              style: {
                background: "#1e293b",
                color: "#f8fafc",
                border: "1px solid #334155",
              },
            }}
          />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;